<template>
<div>
    <v-layout row wrap style="border-bottom: 1px solid black;">
        <v-flex xs12 md6>
            <v-layout row wrap style="border-middle: 3px solid black;">
                <v-checkbox v-model="has_heart_condition" label="Heart"></v-checkbox>
                <v-checkbox v-model="has_asthma_condition" label="Asthma"></v-checkbox>
                <v-checkbox v-model="has_diabetes_condition" label="Diabetes"></v-checkbox>
                <v-checkbox v-model="has_hearing_condition" label="Hearing"></v-checkbox>
                <v-checkbox v-model="has_allergies_condition" label="Allergies"></v-checkbox>
            </v-layout>
            <v-flex xs12 my-4 style="border-bottom: 1px solid black;">
                <v-text-field name="health_problems" label="Specify health or allergies:" :rules="healthProblemsRules" box v-model="health_problems"></v-text-field>
            </v-flex>
            <v-flex xs12 my-3 style="border-bottom: 1px solid black;">
                <v-layout row wrap>
                    <v-flex xs12>Is your child on daily medication?</v-flex>
                    <v-flex xs12 md2 pr-2>
                        <v-select name="is_on_medications" :items="booleans" :rules="medRules" box v-model="is_on_medications"></v-select>
                    </v-flex>
                    <v-flex xs12 md10>
                        <v-text-field name="daily_medications" label="Specify:" :disabled="is_on_medications ? false : true" box v-model="daily_medications"></v-text-field>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 my-3 style="border-bottom: 1px solid black;">
                <v-flex xs12>Do you authorize the health office to give your child acetaminophen (non-aspirin substitute)?</v-flex>
                <v-flex>
                    <v-select name="authorized_to_acetominophize" :items="booleans" :rules="acetominophizeRules" box v-model="authorized_to_acetominophize"></v-select>
                </v-flex>
            </v-flex>
            <v-flex xs12 my-3 style="border-bottom: 1px solid black;">
                <v-text-field name="recent_surgeries" label="Recent surgery or illness (past year)" :rules="recentSurgeries" box v-model="recent_surgeries"></v-text-field>
            </v-flex>
        </v-flex>
        <v-flex xs12 md6 px-2>
            <v-layout column align-content-center justify-center fill-height>
                <li :class="{'health-conditions-xs': $vuetify.breakpoint.xs, 'health-conditions-md': $vuetify.breakpoint.md, 'health-conditions-lg': $vuetify.breakpoint.lg }">I understand Mesa Public Schools does not provide accident medical/dental coverage for students for injuries/illnesses occurring at school. I understand I may voluntarily purchase a student accident insurance plan.</li>
                <br>
                <li :class="{'health-conditions-xs': $vuetify.breakpoint.xs, 'health-conditions-md': $vuetify.breakpoint.md, 'health-conditions-lg': $vuetify.breakpoint.lg }">I understand I am financially responsible for any medical, dental, ambulance, or other health care expenses or transportation of my child home, which might occur as a result of such illness or injury.</li>
                <br>
                <li :class="{'health-conditions-xs': $vuetify.breakpoint.xs, 'health-conditions-md': $vuetify.breakpoint.md, 'health-conditions-lg': $vuetify.breakpoint.lg }">I understand if my child needs medication or other health services at school, I must make arrangements with the school health office.</li>
                <br>
            </v-layout>
        </v-flex>
    </v-layout>
</div>
</template>

<script>
import {
    mapState,
    mapMutations
} from "vuex";
export default {
    data() {
        return {
            booleans: [{
                text: "Yes",
                value: true
            }, {
                text: "No",
                value: false
            }],
            healthProblemsRules: [
                v => !!v || 'This field is required'
            ], 
            medRules: [
                v => v===true || v===false || 'Field is required'
            ],
            acetominophizeRules: [
                v => v===true || v===false || 'Field is required'
            ],
            recentSurgeries: [
                v => !!v || 'This field is required'
            ], 
        };
    },
    computed: {
        has_heart_condition: {
            get() {
                return this.$store.state.registration.healthConditions
                    .has_heart_condition;
            },
            set(value) {
                this.$store.commit(
                    "registration/healthConditions/setHasHeartCondition",
                    value
                );
            }
        },
        has_asthma_condition: {
            get() {
                return this.$store.state.registration.healthConditions
                    .has_asthma_condition;
            },
            set(value) {
                this.$store.commit(
                    "registration/healthConditions/setHasAsthmaCondition",
                    value
                );
            }
        },
        has_diabetes_condition: {
            get() {
                return this.$store.state.registration.healthConditions
                    .has_diabetes_condition;
            },
            set(value) {
                this.$store.commit(
                    "registration/healthConditions/setHasDiabetesCondition",
                    value
                );
            }
        },
        has_hearing_condition: {
            get() {
                return this.$store.state.registration.healthConditions
                    .has_hearing_condition;
            },
            set(value) {
                this.$store.commit(
                    "registration/healthConditions/setHasHearingCondition",
                    value
                );
            }
        },
        has_allergies_condition: {
            get() {
                return this.$store.state.registration.healthConditions
                    .has_allergies_condition;
            },
            set(value) {
                this.$store.commit(
                    "registration/healthConditions/setHasAllergiesCondition",
                    value
                );
            }
        },
        health_problems: {
            get() {
                return this.$store.state.registration.healthConditions.health_problems;
            },
            set(value) {
                this.$store.commit(
                    "registration/healthConditions/setHealthProblems",
                    value
                );
            }
        },
        is_on_medications: {
            get() {
                return this.$store.state.registration.healthConditions
                    .is_on_medications;
            },
            set(value) {
                this.$store.commit(
                    "registration/healthConditions/setIsOnMedications",
                    value
                );
            }
        },
        daily_medications: {
            get() {
                return this.$store.state.registration.healthConditions
                    .daily_medications;
            },
            set(value) {
                this.$store.commit(
                    "registration/healthConditions/setDailyMedications",
                    value
                );
            }
        },
        authorized_to_acetominophize: {
            get() {
                return this.$store.state.registration.healthConditions
                    .authorized_to_acetominophize;
            },
            set(value) {
                this.$store.commit(
                    "registration/healthConditions/setAuthorizedToAcetominophize",
                    value
                );
            }
        },
        recent_surgeries: {
            get() {
                return this.$store.state.registration.healthConditions.recent_surgeries;
            },
            set(value) {
                this.$store.commit(
                    "registration/healthConditions/setRecentSurgeries",
                    value
                );
            }
        }
    }
};
</script>

<style >
/* .health-conditions-xs {
    font-size: 16px !important;
    font-weight: 400;
    line-height: 32px !important;
    letter-spacing: normal !important;
    font-family: "Roboto", sans-serif !important;
    
}

.health-conditions-md {
    font-size: 20px !important;
    font-weight: 400;
    line-height: 32px !important;
    letter-spacing: normal !important;
    font-family: "Roboto", sans-serif !important;
}

.health-conditions-lg {
    font-size: 24px !important;
    font-weight: 400;
    line-height: 32px !important;
    letter-spacing: normal !important;
    font-family: "Roboto", sans-serif !important;
} */
</style>
